import { deepSignal } from "deepsignal";
import { useEffect } from "preact/hooks";

export const TwitchConfig = {
  twitchUsername: "",
  twitchAccessToken: "",
  twitchRefreshToken: "",
  twitchBroadcasterID: "",
  twitchCampaignID: "",
  twitchCampaignGoal: "0.00",
  twitchCampaignName: "",
};

const twitchConfig = deepSignal(TwitchConfig);

const useTwitchConfig = () => {
  useEffect(() => {
    Object.keys(twitchConfig).forEach((key) => {
      twitchConfig[key] = localStorage.getItem(key) ?? twitchConfig[key] ?? null;
    });
  });

  return twitchConfig;
};

export default useTwitchConfig;
